import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DepartureBoardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"departure_board"}/>
}
